import React from 'react'

const s = { fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' }

export const iconMap = {
  car: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" {...s}>
      <path d="M5 17H3a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h14l4 4v4a2 2 0 0 1-2 2h-2" />
      <circle cx="7" cy="17" r="2" /><circle cx="17" cy="17" r="2" />
    </svg>
  ),
  headset: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" {...s}>
      <path d="M3 11l19-9-9 19-2-8-8-2z" />
    </svg>
  ),
  'shopping-bag': () => (
    <svg width="20" height="20" viewBox="0 0 24 24" {...s}>
      <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
      <line x1="3" y1="6" x2="21" y2="6" />
      <path d="M16 10a4 4 0 0 1-8 0" />
    </svg>
  ),
  tool: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" {...s}>
      <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
    </svg>
  ),
  'car-garage': () => (
    <svg width="20" height="20" viewBox="0 0 24 24" {...s}>
      <rect x="2" y="7" width="20" height="14" rx="2" />
      <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
      <line x1="12" y1="12" x2="12" y2="16" />
      <line x1="10" y1="14" x2="14" y2="14" />
    </svg>
  ),
  'layout-grid': () => (
    <svg width="20" height="20" viewBox="0 0 24 24" {...s}>
      <rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" />
      <rect x="14" y="14" width="7" height="7" /><rect x="3" y="14" width="7" height="7" />
    </svg>
  ),
  trophy: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" {...s}>
      <polyline points="8 21 12 17 16 21" />
      <line x1="12" y1="17" x2="12" y2="11" />
      <path d="M7 4h10v7a5 5 0 0 1-10 0V4z" />
      <path d="M7 4H4v3a3 3 0 0 0 3 3M17 4h3v3a3 3 0 0 1-3 3" />
    </svg>
  ),
  help: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" {...s}>
      <circle cx="12" cy="12" r="10" />
      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  ),
  squares: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" {...s}>
      <rect x="2" y="2" width="9" height="9" /><rect x="13" y="2" width="9" height="9" />
      <rect x="13" y="13" width="9" height="9" /><rect x="2" y="13" width="9" height="9" />
    </svg>
  ),
  shield: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" {...s}>
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </svg>
  ),
  bug: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" {...s}>
      <circle cx="12" cy="13" r="4" />
      <path d="M12 9V6M4 13H2M22 13h-2M4.22 4.22l1.42 1.42M18.36 5.64l-1.42 1.42M6 18l-2 2M18 18l2 2" />
    </svg>
  ),
  network: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" {...s}>
      <rect x="9" y="2" width="6" height="4" rx="1" />
      <rect x="2" y="18" width="6" height="4" rx="1" />
      <rect x="16" y="18" width="6" height="4" rx="1" />
      <line x1="12" y1="6" x2="12" y2="12" />
      <line x1="5" y1="18" x2="12" y2="12" />
      <line x1="19" y1="18" x2="12" y2="12" />
    </svg>
  ),
}
